export const VERIFY_PHONE_NUMBER = {
  root: 'verify-phone-number',
  sendNewCode: 'send-new-phone-code',
  checkout: 'verify-phone-number-checkout-as-guest',
  otpInput: 'otp-input',
  loginWithEmail: 'login-with-email',
  id: 'verify-phone-number-id'
};
